import { ISoundSettings } from '@GameStore/GameStoreSchema';

export interface ILocalStorageItem {
    key: string;
    value: string;
}

export interface ILocalStorageConfiguration {
    [LocalStorageItemKeys.GAME_PLAY_IN_AUTO_MODE]?: any;
    [LocalStorageItemKeys.GAME_AUTO_SETTINGS]?: any;
    [LocalStorageItemKeys.GAME_SOUNDS_SETTINGS]?: ISoundSettings;
    [LocalStorageItemKeys.GAME_GAMBLE_SETTINGS]?: any;
    [LocalStorageItemKeys.GAME_BET]?: any;
    [LocalStorageItemKeys.GAME_PLAY_BACKGROUND_SOUND]?: any;
    [LocalStorageItemKeys.GLOBAL_VOLUME]?: any;
    [LocalStorageItemKeys.WCA_MODE]?: any;
    [LocalStorageItemKeys.SHOW_INTRO_MOVIE]?: any;
    [LocalStorageItemKeys.SHOW_PRELOADER_INFO]?: any;
    [LocalStorageItemKeys.LOCAL_FIXES]?: any;
    [LocalStorageItemKeys.LEFT_HAND_MODE]?: any;
}

export enum LocalStorageItemKeys {
    GAME_PLAY_IN_AUTO_MODE = 'playInAutoMode',
    GAME_AUTO_SETTINGS = 'autoSettings',
    GAME_SOUNDS_SETTINGS = 'soundsSettings',
    GAME_GAMBLE_SETTINGS = 'gambleSettings',
    GAME_BET = 'gameBet',
    GAME_PLAY_BACKGROUND_SOUND = 'gamePlayBackgroundSound',
    WCA_MODE = 'wcaMode',
    GLOBAL_VOLUME = 'globalVolume',
    SHOW_PRELOADER_INFO = 'showPreloaderInfo',
    SHOW_INTRO_MOVIE = 'showIntroMovie',
    LOCAL_FIXES = 'localFixes',
    LEFT_HAND_MODE = 'leftHandMode'
}
